import { render, staticRenderFns } from "./testimonial-carousel.vue?vue&type=template&id=24147a64"
import script from "./testimonial-carousel.vue?vue&type=script&lang=js"
export * from "./testimonial-carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports